<template>
  <t-form labelWidth="90px">
    <t-form-item label="快捷跳转">
      <t-switch v-model="attribute.autoSwitch" size="small" :label="['开', '关']" />
    </t-form-item>
    <t-form-item label="总数量">
      <t-switch v-model="attribute.autoSwitch_num" size="small" :label="['开', '关']" />
    </t-form-item>
    <t-form-item label="分页下拉">
      <t-switch v-model="attribute.autoSwitch_dropdown" size="small" :label="['开', '关']" />
    </t-form-item>
    <t-form-item label="当前页">
      <t-input-number v-model="attribute.current" theme="column" :min="0" />
    </t-form-item>
    <t-form-item label="总条数">
      <t-input-number v-model="attribute.total" theme="column" :min="0" />
    </t-form-item>
    <t-form-item label="页大小">
      <t-select v-model="attribute.pageSize" size="small" @change="onChangePageSize">
        <t-option v-for="(item, index) in attribute.pageSizeOptions" :key="index" :label="item.label"
          :value="item.value" />
      </t-select>
    </t-form-item>
    <t-form-item label="组件尺寸">
      <t-radio-group variant="primary-filled" default-value="small" v-model="attribute.size">
        <t-radio-button value="small">小</t-radio-button>
        <t-radio-button value="medium">中</t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="文字颜色">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        size="small"
        v-model="attribute.textColor"
        enableAlpha
      />
    </t-form-item>
    <t-form-item label="箭头颜色">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        size="small"
        v-model="attribute.textColorArrow"
        enableAlpha
      />
    </t-form-item>
    <t-form-item label="背景颜色">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        size="small"
        v-model="attribute.backgroundColor"
        enableAlpha
      />
    </t-form-item>
    <t-form-item label="选中背景颜色">
      <t-color-picker
        :colorModes="['monochrome']"
        format="RGBA"
        size="small"
        v-model="attribute.backgroundColorCurrent"
        enableAlpha
      />
    </t-form-item>
</t-form>
</template>
<script>
export default {
  name: "cpt-page-option",
  props: { attribute: Object, currentCpt: Object, refMap: Object },
  data() {
    return {

    };
  },
  methods:{
    onChangePageSize(pageSize) {
      let pageEvent = this.currentCpt.cptOption.interaction.eventList.find(x => x.intType === 'setPages')
      
      if(!pageEvent) {
        return
      }

      // 九宫格处理
      if(pageEvent.activePageKey === 'cpt-ninegrid') {
        this.refMap[pageEvent.activePageId].pageChange({ pageSize, current: 1})
      }
    }
  }
};
</script>